(function () {
  'use strict';

  const DEBUG = false;
  const SYNC_EVENTS = [
    'DOMContentLoaded',
    'shopify:section:load',
    'theme:filter:update',
    'filter:update',
    'FilterUpdate',
  ];

  function log(...args) {
    if (DEBUG) console.log('[ForcedGlaze]', ...args);
  }

  function handleize(value) {
    return String(value || '')
      .toLowerCase()
      .normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '')
      .replace(/[^a-z0-9]+/g, '-')
      .replace(/^-+|-+$/g, '');
  }

  function inputMatchesGlaze(input, glaze) {
    const glazeHandle = handleize(glaze);
    if (!glazeHandle) return false;

    const label = input.closest('label');
    if (!label) return false;

    const title = label.getAttribute('title') || '';
    const ariaLabel = label.getAttribute('aria-label') || '';
    const text = label.textContent || '';
    const candidates = [title, ariaLabel, text]
      .flatMap((value) => {
        if (!value.includes('|') && !value.includes(' with ')) return [value];
        return [
          value,
          value.split('|').pop(),
          value.split(' with ').pop(),
        ];
      })
      .map((value) => handleize(value));

    return candidates.some(
      (candidate) =>
        candidate === glazeHandle ||
        candidate.startsWith(`${glazeHandle}-`) ||
        candidate.endsWith(`-${glazeHandle}`)
    );
  }

  function findInputForGlaze(productCard, glaze) {
    const inputs = Array.from(productCard.querySelectorAll('input[data-variant-id]'));
    const matchingInputs = inputs.filter((input) => inputMatchesGlaze(input, glaze));

    return (
      matchingInputs.find((input) => input.dataset.available !== 'false' && !input.disabled) ||
      matchingInputs.find((input) => !input.disabled) ||
      matchingInputs[0] ||
      null
    );
  }

  function scopeRadioGroups(card, productCard) {
    const scope = handleize(card.dataset.productCardId || card.id || card.dataset.forcedGlaze);
    if (!scope) return;

    productCard.querySelectorAll('input[type="radio"][name]').forEach((input) => {
      if (!input.dataset.originalName) {
        input.dataset.originalName = input.name;
      }

      input.name = `${input.dataset.originalName}--${scope}`;
    });
  }

  function syncForcedCard(card) {
    const productCard = card.querySelector('product-card');
    const forcedGlaze = card.dataset.forcedGlaze;

    if (!productCard || !forcedGlaze) return false;

    scopeRadioGroups(card, productCard);

    const input = findInputForGlaze(productCard, forcedGlaze);
    if (!input) {
      log('No matching input for forced glaze', forcedGlaze, card.id);
      return false;
    }

    const variantId = input.dataset.variantId;
    const cardGallery = productCard.querySelector('[ref="cardGallery"]');

    if (cardGallery && variantId) {
      // Only drop the server-rendered hover URL when we're forcing a DIFFERENT
      // variant than the one the server rendered it for. Removing it
      // unconditionally pushed every hover on filtered grids through a slow,
      // fallback-less network fetch, so hovers appeared broken.
      const serverHoverVariantId = cardGallery.getAttribute('data-variant-id-for-hover');
      if (serverHoverVariantId !== variantId) {
        cardGallery.removeAttribute('data-hover-image-url');
      }
      cardGallery.setAttribute('data-active-variant-id', variantId);
      cardGallery.setAttribute('data-forced-variant-id', variantId);
      cardGallery.setAttribute('data-variant-id-for-hover', variantId);
      cardGallery.removeAttribute('data-forced-glaze-locked');
      cardGallery.removeAttribute('data-forced-glaze-unavailable');
    }

    input.checked = true;
    input.dataset.forcedGlazeSync = 'true';
    input.dispatchEvent(new Event('change', { bubbles: true }));
    delete input.dataset.forcedGlazeSync;

    card.dataset.processed = 'true';
    return true;
  }

  let syncFrame = null;

  function syncForcedCards() {
    syncFrame = null;
    const cards = document.querySelectorAll('li.product-grid__item[data-forced-glaze]');

    cards.forEach((card) => {
      if (card instanceof HTMLElement) syncForcedCard(card);
    });
  }

  function scheduleSync() {
    if (syncFrame !== null) return;
    syncFrame = window.requestAnimationFrame(syncForcedCards);
  }

  function scheduleSettlingSyncs() {
    scheduleSync();
    window.setTimeout(scheduleSync, 80);
    window.setTimeout(scheduleSync, 250);
  }

  SYNC_EVENTS.forEach((eventName) => {
    document.addEventListener(eventName, scheduleSettlingSyncs);
  });

  window.addEventListener('pageshow', scheduleSettlingSyncs);

  const observer = new MutationObserver((mutations) => {
    const shouldSync = mutations.some((mutation) =>
      Array.from(mutation.addedNodes).some(
        (node) =>
          node instanceof HTMLElement &&
          (node.matches('li.product-grid__item[data-forced-glaze]') ||
            node.querySelector('li.product-grid__item[data-forced-glaze]'))
      )
    );

    if (shouldSync) scheduleSettlingSyncs();
  });

  function observeResults() {
    const target = document.querySelector('results-list') || document.querySelector('.product-grid');
    if (target) observer.observe(target, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', observeResults, { once: true });
  } else {
    observeResults();
    scheduleSettlingSyncs();
  }
})();
